import {
  AUTH_ERROR,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  REFRESH_REQUEST,
  SET_USER_ID,
  SET_USERNAME,
  USER_ERROR,
  USER_REQUEST,
  USER_SUCCESS,
  LOGOUT,
  LOGOUT_SUCCESS,
  REGISTER,
  CONFIRM_EMAIL,
  CONFIRM_EMAIL_ERROR,
  CONFIRM_EMAIL_LOADING,
  CONFIRM_EMAIL_SUCCESS,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_LOADING,
  FORGOT_PASSWORD_SUCCESS,
  POST_NEW_PASSWORD,
  POST_NEW_PASSWORD_ERROR,
  POST_NEW_PASSWORD_LOADING,
  POST_NEW_PASSWORD_SUCCESS,
  SET_USER_ROLES,
  USER_ROLES_REQUEST,
  SET_PASSWORD, FETCH_SECURITY_QUESTIONS,
} from '@/app/auth/store/types';
import { SET_ROUTE_TO_REDIRECT } from '@/app/admin/store/types';

import { http } from '@/api';
import { SET_FILING_DECISION } from '@/app/file/store/types';
import { SET_IS_APP_ACCESS_PAID, SET_APP_ACCESS_TYPE } from '@/app/main/store/types';


const USER_TOKEN = 'user-token';
const REFRESH_TOKEN = 'refresh-token';
const USER_ID = 'user-id';
const USER_NAME = 'user-name';
const ADMIN_GROUP = 'admin-group';

export const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => new Promise(((resolve, reject) => {
    commit(AUTH_REQUEST);
    http.post('/auth/login', user)
      .then((resp) => {
        const token = resp.data.accessToken;
        const { refreshToken } = resp.data;
        localStorage.setItem(USER_TOKEN, token);
        localStorage.setItem(REFRESH_TOKEN, refreshToken);
        http.defaults.headers.common.Authorization = `Bearer ${token}`;
        commit(AUTH_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          dispatch(REFRESH_REQUEST);
        } else {
          commit(AUTH_ERROR, err);
          localStorage.removeItem(USER_TOKEN);
          localStorage.removeItem(REFRESH_TOKEN);
          reject(err);
        }
      });
  })),
  [REFRESH_REQUEST]: ({ commit, dispatch }) => new Promise(((resolve) => {
    const refreshTokenData = {
      refreshToken: localStorage.getItem(REFRESH_TOKEN),
    };
    commit(AUTH_REQUEST);
    http.post('/auth/refresh-token', refreshTokenData)
      .then((resp) => {
        const token = resp.data.accessToken;
        const { refreshToken } = resp.data;
        localStorage.setItem(USER_TOKEN, token);
        localStorage.setItem(REFRESH_TOKEN, refreshToken);
        http.defaults.headers.common.Authorization = `Bearer ${token}`;
        commit(AUTH_SUCCESS, resp);
        dispatch(USER_REQUEST);
        resolve(resp);
      })
      .catch(() => {
        dispatch(LOGOUT);
      });
  })),
  [USER_REQUEST]: ({ commit, dispatch }) => new Promise(((resolve) => {
    commit(USER_REQUEST);
    http.get('/auth/me')
      .then((resp) => {
        commit(USER_SUCCESS, resp);
        const username = `${resp.data.firstName || 'John'} ${resp.data.lastName || 'Doe'}`;
        localStorage.setItem(USER_NAME, username);
        commit(SET_USERNAME, username);
        if (resp.data.roles.length) {
          localStorage.setItem(ADMIN_GROUP, 'true');
          commit(SET_USER_ROLES, resp.data.roles);
          resolve(resp);
        }
        if (resp.data.currentUserApplication != null) {
          const userId = resp.data.currentUserApplication.id;
          const { filingType } = resp.data.currentUserApplication;
          localStorage.setItem(USER_ID, userId);
          commit(SET_USER_ID, userId);
          commit(SET_FILING_DECISION, filingType);
          commit(SET_IS_APP_ACCESS_PAID, resp.data.currentUserApplication.isAppAccessPaid);
        }
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST)
            .then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            });
        } else {
          commit(USER_ERROR);
          dispatch(LOGOUT);
        }
      });
  })),
  [LOGOUT]: ({ commit }) => new Promise(((resolve) => {
    commit(LOGOUT_SUCCESS);
    localStorage.removeItem(USER_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(USER_NAME);
    localStorage.removeItem(USER_ID);
    localStorage.removeItem(ADMIN_GROUP);
    commit(SET_ROUTE_TO_REDIRECT, '');
    resolve();
  })),
  // eslint-disable-next-line no-empty-pattern
  [REGISTER]: ({}, user) => new Promise(((resolve, reject) => {
    http.post('/auth/register', user)
      .then((resp) => {
        const { email } = user;
        localStorage.setItem(email, user.clientMachineToken);
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  })),
  [CONFIRM_EMAIL]: ({ commit }, confirmData) => new Promise((resolve, reject) => {
    commit(CONFIRM_EMAIL_LOADING);
    http.post('/auth/confirm-email', confirmData)
      .then((resp) => {
        commit(CONFIRM_EMAIL_SUCCESS);
        resolve(resp);
      })
      .catch((err) => {
        commit(CONFIRM_EMAIL_ERROR);
        reject(err);
      });
  }),
  [FORGOT_PASSWORD]: ({ commit }, emailData) => new Promise((resolve, reject) => {
    commit(FORGOT_PASSWORD_LOADING);
    http.post('/auth/forgot-password', emailData)
      .then((resp) => {
        commit(FORGOT_PASSWORD_SUCCESS);
        resolve(resp);
      })
      .catch((err) => {
        commit(FORGOT_PASSWORD_ERROR);
        reject(err);
      });
  }),
  [POST_NEW_PASSWORD]: ({ commit }, data) => new Promise((resolve, reject) => {
    commit(POST_NEW_PASSWORD_LOADING);
    http.post('/auth/reset-password', data)
      .then((resp) => {
        commit(POST_NEW_PASSWORD_SUCCESS);
        resolve(resp);
      })
      .catch((err) => {
        commit(POST_NEW_PASSWORD_ERROR);
        reject(err);
      });
  }),
  [USER_ROLES_REQUEST]: ({ commit, dispatch }) => new Promise(((resolve) => {
    const token = localStorage.getItem(USER_TOKEN);
    if (token) {
      http.get('/auth/me', {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((resp) => {
          commit(SET_USER_ROLES, resp.data.roles);
          commit(SET_APP_ACCESS_TYPE, { appAccessType: 0, roles: resp.data.roles });

          resolve(resp);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(REFRESH_REQUEST).then(() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            });
          } else {
            dispatch(LOGOUT);
          }
        });
    }
  })),
  // eslint-disable-next-line no-empty-pattern
  [SET_PASSWORD]: ({}, data) => new Promise((resolve, reject) => {
    http.post('/admin/agents/set-password', data)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  // eslint-disable-next-line no-empty-pattern
  [FETCH_SECURITY_QUESTIONS]: ({}) => http.get('/lookup/security-questions'),
};
